import { ItemIdToQuantity, ItemIdToValidation, Validation } from '../index'
import { TransactionItem } from '../../../../../../../graphql'

export function validateItem( item: TransactionItem, itemQuantities: ItemIdToQuantity ) {
	let validation: Validation = { isInvalid: false }

	if ( itemQuantities[ item.id ] ) {
		const received = parseInt( itemQuantities[ item.id ], 10 )
		if ( isNaN( received ) ) {
			validation = { isInvalid: true, error: 'Quantity must be a number' }
		} else if ( received > item.quantityOrdered ) {
			validation = { isInvalid: true, error: 'Qty must be less than ordered' }
		} else if ( received < 0 ) {
			validation = { isInvalid: true, error: 'Quantity must be positive' }
		}
	}

	return validation
}

export default function validateForm( items: TransactionItem[], itemQuantities: ItemIdToQuantity ) {
	const itemValidation: ItemIdToValidation = {}
	const isInvalid = items.reduce( ( isAnyItemInvalid, item ) => {
		const validation = validateItem( item, itemQuantities )
		itemValidation[ item.id ] = validation

		return isAnyItemInvalid || validation.isInvalid
	}, false )

	return {
		isInvalid,
		newItemValidation: itemValidation,
	}
}
